import React from "react";
import DocumentsLibrary from "@/altzero_plugins/features/scopingai/scopingAi/features/scopingAi/pages/DocumentsLibrary";
import { supabaseRevisr } from "@/features/revisr/utils/supabaseRevisrClient";
import type { TemplateServiceConfig } from "@/altzero_plugins/features/scopingai/scopingAi/features/scopingAi/services/documentLibraryService";

// Pass-through layout — suppresses the default ScopingAI sidebar
const PassthroughLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <>{children}</>
);

const TEMPLATE_SERVICE_CONFIG: TemplateServiceConfig = {
  supabaseClient: supabaseRevisr as unknown as TemplateServiceConfig["supabaseClient"],
  tableName: "policy_templates",
  bucketName: "templates",
};

const SETTINGS_TEMPLATES_CONFIG = {
  layout: PassthroughLayout,
  routes: {
    back: "",
    backLabel: "",
    templateCreate: "/revisr/templates/create",
    templateEditorNew: "/revisr/template-editor/new",
    templateEditorById: (id: string) => `/revisr/template-editor/${id}`,
    documentNew: "/revisr/templates",
  },
  labels: {
    title: "Policy Templates",
    subtitle: "Manage and organize your policy templates",
  },
  serviceConfig: TEMPLATE_SERVICE_CONFIG,
};

export const TemplatesSection: React.FC = () => (
  <DocumentsLibrary config={SETTINGS_TEMPLATES_CONFIG} />
);
